import { InformationCircleIcon } from '@heroicons/react/24/outline'
import { EmptyValuePlaceholder } from "@/components/ui"
import Address from '@/components/Address'

export default ({entity = "", address = "", entitiesList = {}}) => (
  <div className="relative">
    <div className="flex items-center">
      <span>{entitiesList[entity] || <EmptyValuePlaceholder />}</span>
      { address &&
        <div className="dropdown dropdown-hover">
          <div tabIndex={0} role="button" className="btn btn-circle btn-ghost btn-xs m-1"><InformationCircleIcon className="size-5" /></div>
          <div tabIndex={0} className="card dropdown-content w-80 bg-base-100 rounded-box z-1 p-2 shadow-sm">
            <div tabIndex={0} className="card-body">
              <div>{address.nom || ''}</div>
                { address.complement && 
                  <div className="uppercase">{address.complement}</div>
                }
                <Address data={ address || {}}/>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
)